import React from 'react'
import cn from 'classnames'

import ReceiptDetails from '../../containers/receipt/ReceiptDetails'
import styles from './ReceiptCard.module.scss'

const ReceiptCard = ({ className }) => {
  const classNames = cn(styles.receiptCard, className)

  return (
    <div className={classNames}>
      <ReceiptDetails/>
    </div>
  )
}

export default ReceiptCard
